import { render, staticRenderFns } from "./LayoutHorizontal.vue?vue&type=template&id=0e5c34c5"
import script from "./LayoutHorizontal.vue?vue&type=script&lang=js"
export * from "./LayoutHorizontal.vue?vue&type=script&lang=js"
import style0 from "./LayoutHorizontal.vue?vue&type=style&index=0&id=0e5c34c5&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e5c34c5')) {
      api.createRecord('0e5c34c5', component.options)
    } else {
      api.reload('0e5c34c5', component.options)
    }
    module.hot.accept("./LayoutHorizontal.vue?vue&type=template&id=0e5c34c5", function () {
      api.rerender('0e5c34c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/layout-horizontal/LayoutHorizontal.vue"
export default component.exports